import { render, staticRenderFns } from "./pic-add.vue?vue&type=template&id=08e4f8d6&scoped=true&"
import script from "./pic-add.vue?vue&type=script&lang=js&"
export * from "./pic-add.vue?vue&type=script&lang=js&"
import style0 from "./pic-add.vue?vue&type=style&index=0&id=08e4f8d6&lang=less&scoped=true&"
import style1 from "@/assets/less/i-switch.less?vue&type=style&index=1&id=08e4f8d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e4f8d6",
  null
  
)

component.options.__file = "pic-add.vue"
export default component.exports